import React, { useState, useContext } from "react";

import Slider, { Settings } from "react-slick";
import { observer } from "mobx-react";

import { OfferStoreContext } from "@gp/components";

import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import BetBuilderPicksEventSliderItem from "./components/BetBuilderPicksEventSliderItem";

export default observer(function BetBuilderPicksEventSlider() {
	const store = useContext(OfferStoreContext) as
		| AdditionalOfferViewStore
		| EventViewStore;
	const [isDragging, setIsDragging] = useState(false);

	if (
		!store?.betBoosterEventPicks?.betBuilderPicksStore?.betBuilderPresetIds
			?.length
	) {
		return null;
	}

	const settings: Settings = {
		arrows: true,
		dots: false,
		infinite: false,
		variableWidth: true,
		speed: 300,

		slidesToShow: store instanceof EventViewStore ? 2 : 1,
		slidesToScroll: store instanceof EventViewStore ? 2 : 1,
		touchThreshold: 100,

		responsive: [
			{
				breakpoint: 1669,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 1360,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],

		beforeChange: () => setIsDragging(true),
		afterChange: () => setIsDragging(false),
	};

	return (
		<div className="card--carousel card--carousel--bbp">
			<div className="card--carousel__body u-padd--reset">
				<Slider
					{...settings}
					className="carousel carousel--most carousel--arrows carousel--arrows--sml"
				>
					{store?.betBoosterEventPicks?.betBuilderPicksStore?.betBuilderPresetIds?.map(
						(item, index) => {
							const slip =
								store?.betBoosterEventPicks?.betBuilderPicksStore?.BBPicks.get(
									item
								);
							if (!slip) {
								return null;
							}
							return (
								<div
									key={slip.id}
									className="carousel__item carousel--most__item"
								>
									<BetBuilderPicksEventSliderItem
										BBPick={slip}
										key={slip.id}
										index={index}
										isDragging={isDragging}
										activatePopup={
											store.betBoosterEventPicks
												.betBuilderPicksStore!
												.activatePopup
										}
									/>
								</div>
							);
						}
					)}
				</Slider>
			</div>
		</div>
	);
});
